import { render, staticRenderFns } from "./form-base.vue?vue&type=template&id=329955ca"
import script from "./form-base.vue?vue&type=script&lang=ts"
export * from "./form-base.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports